module.exports = __webpack_public_path__ + "img/room2.45ab5f6e.jpg";